import Swiper, { FreeMode, Navigation, Pagination, Scrollbar } from 'swiper'

const initTestimonialsSwiper = () => {
  new Swiper('.testimonials__swiper.swiper', {
    modules: [Scrollbar, Pagination, Navigation, FreeMode],
    slidesPerView: 1,
    spaceBetween: 24,

    pagination: {
      el: '.testimonials__swiper-pagination',
    },

    navigation: {
      nextEl: '.testimonials__swiper-nav.next',
      prevEl: '.testimonials__swiper-nav.prev',
    },

    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 72,
      },
    },
  })
}

export default initTestimonialsSwiper
